import { useMutation } from "@tanstack/react-query"
import { updateTransferOrderAttachment } from "customerAttachments/apis"
import { TransferAttachType } from "customerAttachments/types"

type useUploadTransferAttachmentsProps = {
  transferId: string
  attachType: TransferAttachType
}

const useUploadTransferAttachments = ({ transferId, attachType }: useUploadTransferAttachmentsProps) => {
  const { mutateAsync, isLoading } = useMutation({
    mutationKey: ["uploadTransferAttachments"],
    mutationFn: (payload: { Files: { FileName: string; Base64: string }[] }) =>
      updateTransferOrderAttachment({ transferId, attachType, payload }),
  })
  return { mutate: mutateAsync, isLoading }
}

export default useUploadTransferAttachments
